/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LastSessionTodaySummary
 */
export interface LastSessionTodaySummary {
    /**
     * 
     * @type {number}
     * @memberof LastSessionTodaySummary
     */
    totalXP?: number;
    /**
     * Total time played today in minutes
     * @type {number}
     * @memberof LastSessionTodaySummary
     */
    totalTime?: number;
    /**
     * Number of unique games played today
     * @type {number}
     * @memberof LastSessionTodaySummary
     */
    uniqueGames?: number;
}

/**
 * Check if a given object implements the LastSessionTodaySummary interface.
 */
export function instanceOfLastSessionTodaySummary(value: object): value is LastSessionTodaySummary {
    return true;
}

export function LastSessionTodaySummaryFromJSON(json: any): LastSessionTodaySummary {
    return LastSessionTodaySummaryFromJSONTyped(json, false);
}

export function LastSessionTodaySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LastSessionTodaySummary {
    if (json == null) {
        return json;
    }
    return {
        
        'totalXP': json['totalXP'] == null ? undefined : json['totalXP'],
        'totalTime': json['totalTime'] == null ? undefined : json['totalTime'],
        'uniqueGames': json['uniqueGames'] == null ? undefined : json['uniqueGames'],
    };
}

export function LastSessionTodaySummaryToJSON(json: any): LastSessionTodaySummary {
    return LastSessionTodaySummaryToJSONTyped(json, false);
}

export function LastSessionTodaySummaryToJSONTyped(value?: LastSessionTodaySummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalXP': value['totalXP'],
        'totalTime': value['totalTime'],
        'uniqueGames': value['uniqueGames'],
    };
}

